var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClearChat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.01052 3.36719H3.36833C2.63582 3.36719 2.04199 3.96102 2.04199 4.69353V16.6306C2.04199 17.3631 2.63582 17.9569 3.36833 17.9569H15.3054C16.0379 17.9569 16.6317 17.3631 16.6317 16.6306V11.9884",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6599 12.6019L6.68262 13.3149L7.34548 9.30121L14.2782 2.43156C14.4015 2.30781 14.5482 2.20958 14.7097 2.14256C14.8713 2.07553 15.0445 2.04102 15.2195 2.04102C15.3945 2.04102 15.5678 2.07553 15.7294 2.14256C15.8909 2.20958 16.0376 2.30781 16.1609 2.43156L17.5661 3.83107C17.6904 3.95381 17.7891 4.09983 17.8563 4.26072C17.9236 4.42161 17.9583 4.59418 17.9583 4.76847C17.9583 4.94277 17.9236 5.11534 17.8563 5.27622C17.7891 5.43712 17.6904 5.58314 17.5661 5.70588L10.6599 12.6019Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearChat);
export default __webpack_public_path__ + "static/media/clear-chat.65da9b3968a41db1b2c04b23c10f7d67.svg";
export { ForwardRef as ReactComponent };